import {ActionType, ActionWidget, Widget} from "../../models/contents.ts";
import {FormControl,  Grid, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import React from "react";
import {Thumbnail} from "../misc/thumbnail.tsx";

function ActionWidgetForm(props: {
  value: ActionWidget
  onChange: (value: Widget) => void
}) {
  if (props.value.form === undefined) {
    props.value.form = {
      type: "fixed_end",
      image: {
        url: props.value.parameters?.url || "",
        w: 0,
      },
    }
    props.onChange(props.value)
    return <></>
  }
  const form = props.value.form!
  return (
    <>
      <Grid item xs={3}>
        <TextField
          fullWidth
          label="type"
          value={props.value.type}
          disabled={true}
        />
      </Grid>
      <Grid item xs={9}>
        <FormControl fullWidth>
          <InputLabel id="type">Type</InputLabel>
          <Select
            labelId="type"
            label="Type"
            onChange={(event) => {
              const newValue = {...props.value}
              newValue.form!.type = event.target.value as ActionType
              props.onChange(newValue)
            }}
            defaultValue={form.type}
          >
            <MenuItem value="fixed_end">fixedEnd</MenuItem>
            <MenuItem value="show_fixed_image">showFixedImage</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      {form.type === "show_fixed_image" && (
       <>
         <Grid item xs={8}>
           <TextField
             fullWidth
             label="url"
             value={props.value.form?.image?.url || props.value.parameters?.url}
             onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
               const newValue = {
                 ...props.value,
                 form: {
                   ...props.value.form,
                   image: {
                     ...props.value.form?.image,
                     url: event.target.value,
                   }
                 }
               }
               props.onChange(newValue)
             }}
           />
         </Grid>
         <Grid item xs={3}>
           {props.value.form?.image?.url && <Thumbnail url={props.value.form?.image?.url}/>}
         </Grid>
         <Grid item xs={2}>
           <TextField
             fullWidth
             label="width when displayed"
             type="number"
             value={props.value.form?.image?.w}
             onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
               if (Number(event.target.value) < 0) {
                 return
               }
               const newValue = {
                 ...props.value,
                 form: {
                   ...props.value.form,
                   image: {
                     ...props.value.form?.image,
                     w: Number(event.target.value),
                   }
                 }
               }
               props.onChange(newValue)
             }}
           />
         </Grid>
       </>
      )}
    </>
  );
}

export default ActionWidgetForm;
